import React from 'react';
import { Segment, Container, Form, Button, Loader } from 'semantic-ui-react';

class UserForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    const { user } = this.props;

    this.state = {
      name: user ? user.name : undefined,
      email: user ? user.email : undefined
    };
  }

  handleInputChange(event, { name, value }) {
    this.setState({ [name]: value });
  }

  handleSubmit() {
    const { name, email } = this.state;

    this.props.onSubmit({
      name,
      email
    });
  }

  render() {
    const { user } = this.props;

    return (
      <Segment basic>
        <Loader active={!user} />
        {user && (
          <Container text>
            <Form size="large" onSubmit={this.handleSubmit}>
              <Form.Field>
                <label>Your name</label>
                <Form.Input
                  placeholder="Your name"
                  name="name"
                  defaultValue={user.name}
                  onChange={this.handleInputChange}
                />
              </Form.Field>
              <Form.Field>
                <label>Your e-mail</label>
                <Form.Input
                  placeholder="Email"
                  name="email"
                  defaultValue={user.email}
                  onChange={this.handleInputChange}
                />
              </Form.Field>
              <Button type="submit">Submit</Button>
            </Form>
          </Container>
        )}
      </Segment>
    );
  }
}

export default UserForm;



// WEBPACK FOOTER //
// ./src/components/UserForm.js